import BaseApi from '@/api/BaseApi';

export class StatisticApi extends BaseApi {
    static resource = 'statistics';

    get endpoints() {
        return {
            get: this.get.bind(this)
        };
    }

    async get(type) {
        const response = await BaseApi.api.get(`${this.base_url}/${type}`);
        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);
        });
    }
}

export default StatisticApi;
